<template>
  <div>
    <v-card>
      <v-card-title color="primary" class="headline lighten-2" style="word-break: break-word;">
        <b v-if="isClient">{{ $t("Please complete your client invoice data:") }}</b>
        <b v-else>{{ $t("Please complete your provider invoice data:") }}</b>
      </v-card-title>
      <v-card-subtitle style="margin-top: 10px">
        <InvoiceImage :image="file" :height="'unset'" :width="'100%'" />
      </v-card-subtitle>
      <v-card-subtitle>
        <v-form
          ref="form"
          v-model="valid"
          style="margin-left: 15px; margin-top: 20px">
          <h4>{{ $t('Invoice Number') }}</h4>
          <v-text-field
            ref="formNumber"
            v-model="number"
            :placeholder="$t('Invoice Number')"
            :rules="rules.value"
            name="value"
          />
          <h4 v-if="!disabledReceiver">
            {{ $t('InvoiceMissingInformation.Payer CIF') }}
          </h4>
          <v-text-field
            v-if="!disabledReceiver"
            ref="formOtherCif"
            v-model="payerCif"
            :disabled="true"
            name="cif"
            :placeholder="$t('InvoiceMissingInformation.Payer CIF')"
            :rules="rules.cif"
            type="text"
            @change="searchEmail(payerCif, 'pay')"
          />
          <h4 v-if="!disabledReceiver">
            {{ $t('InvoiceMissingInformation.Payer Email') }}
          </h4>
          <v-text-field
            v-if="!disabledReceiver"
            ref="formOtherEmail"
            v-model="payerEmail"
            :disabled="true"
            name="email"
            :placeholder="$t('InvoiceMissingInformation.Payer CIF')"
            :rules="rules.email"
            type="text"
            @change="searchEmail(payerEmail, 'pay')"
          />
          <h4 v-if="!disabledPayer">
            {{ $t('InvoiceMissingInformation.Receiver CIF') }}
          </h4>
          <v-text-field
            v-if="!disabledPayer"
            ref="formOtherCif"
            v-model="receiverCif"
            :disabled="true"
            name="cif"
            :placeholder="$t('InvoiceMissingInformation.Receiver CIF')"
            type="text"
            @change="searchEmail(receiverCif,'rec')"
          />
          <h4 v-if="!disabledPayer">
            {{ $t('InvoiceMissingInformation.Receiver Email') }}
          </h4>
          <v-text-field
            v-if="!disabledPayer"
            ref="formOtherEmail"
            v-model="receiverEmail"
            :disabled="true"
            name="email"
            :placeholder="$t('InvoiceMissingInformation.Receiver Email')"
            :rules="rules.email"
            type="text"
            @change="searchEmail(receiverEmail, 'pay')"
          />
          <h4 v-if="!disabledPayer">
            {{ $t('InvoiceMissingInformation.Payer NIF/CIF, Mail & name') }}
          </h4>
          <v-select
            v-if="!disabledPayer"
            v-model="otherSelectedUser"
            prepend-inner-icon="mdi-account"
            :placeholder="$t('InvoiceMissingInformation.Payer NIF/CIF, Mail & name')"
            :items="usersName"
            @change="onChange(otherSelectedUser)"
          />
          <h4 v-if="!disabledReceiver">
            {{ $t('InvoiceMissingInformation.Receiver NIF/CIF, Mail & name') }}
          </h4>
          <v-select
            v-if="!disabledReceiver" 
            v-model="otherSelectedUser"
            prepend-inner-icon="mdi-account"
            :placeholder="'Receiver NIF/CIF, Mail & Name'"
            :items="usersName"
            @change="onChange(otherSelectedUser)"
          />
          <v-btn text color="#00E5FF" @click="modalContact = true">
            {{ $t('+ Add Contact') }}
          </v-btn>
          <v-dialog
            ref="dialog"
            v-model="modalContact"
            width="320px">
            <v-form v-model="valid2" style="background-color: white;">
              <v-text-field
                v-model="contactName"
                :label="$t('Contact Name')"
                append-icon="mdi-account"
                style="margin-left: 20px; margin-right: 20px; width: 280px;"
                :rules="rules.name"
              />
              <v-text-field
                v-model="contactNIF"
                :label="$t('Contact NIF/CIF')"
                append-icon="mdi-passport"
                style="margin-left: 20px; margin-right: 20px; width: 280px"
                :rules="rules.cif"
              />
              <v-text-field
                v-model="contactEmail"
                :label="$t('Contact Email')"
                append-icon="mdi-email"
                style="margin-left: 20px; margin-right: 20px; width: 280px"
                :rules="rules.email"
              />
              <v-btn :disabled="!valid2" style="margin-left: 90px" text color="#00E5FF" @click="addContact()">
                {{ $t('ADD CONTACT') }}
              </v-btn>
            </v-form>
          </v-dialog>
          <h4>{{ $t('Amount') }}</h4>
          <v-text-field
            ref="formValue"
            v-model="amount"
            :disabled="disabledAmount"
            name="value"
            :placeholder="$t('Amount')"
            type="number"
            @change="calculateComissions"
          />
          <h4 v-if="!forward">
            {{ $t('Account number') }}
          </h4>
          <v-text-field
            v-if="!forward"
            ref="formEmail"
            v-model="account"

            :label="$t('Account number')"
            name="account"
            type="text"
          />
        </v-form>
      </v-card-subtitle>
      <v-card-actions>
        <v-container>
          <v-col>
            <v-row justify="center">
              <v-col cols="12" align="center">
                <v-btn :disabled="!valid" x-large style="padding: 15px 75px; bottom: 25px" depressed class="btn-primary" dark @click="saveInvoice()">
                  <v-icon style="margin-right: 5px">
                    mdi-content-save-all
                  </v-icon>{{ $t('Save') }}
                </v-btn>
              </v-col>
            </v-row>
            <v-row justify="center">
              <v-col cols="12" align="center">
                <v-btn class="ml-2" x-large style="padding: 15px 75px; bottom: 25px" text @click="noInfo()">
                  <v-icon style="margin-right: 5px">
                    mdi-undo-variant
                  </v-icon>{{ $t('Back') }}
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-container>
      </v-card-actions>
    </v-card>
  </div>
</template>
<script>
import ApiRepository from "../repositories/ApiRepository";
import Constants from "../../constants";
import InvoiceImage from "../components/invoice/InvoiceImage";

export default {
    name: "InvoiceMissingInformation",
    components: { InvoiceImage },
    props: {
        invoice: {
            type: Object,
            default: null
        },
        forward: {
            type: Boolean,
            default: false
        },
        file: {
            type: String,
            default: null
        }
    },
    data () {
        return {
            modalContact: null,
            usersName: [],
            otherSelectedUser: '',
            contactNIF: '',
            contactName: '',
            contactEmail: '',
            visible: false,
            camera: null,
            frame: null,
            image: null,
            valid: false,
            isClient: false,
            color: "primary",
            colorP: "primary",
            colorC: "primary",
            uploadImage: true,
            visibleInformation: false,
            receiver: null,
            payer: null,
            amount: null,
            number: null,
            account: null,
            factorComission: null,
            payerComission: null,
            receiverCif: '',
            receiverEmail: '',
            payerCif: '',
            valid2: false,
            payerEmail: '',
            rules: {
                value: [v => !!v || this.$t('The value field is required'), ],
                number: [v => !!v || this.$t('Error.This field is required'), ],
                cif: [
                    val => (val || '').length > 0 || this.$t('Error.This field is required'),
                    v => this.receiverCif.toUpperCase() !== this.payerCif.toUpperCase() || this.$t('Error.The CIF must be different than yours.'),
                    //v => /^[a-zA-Z0-9]{1}[0-9]{7}[a-zA-Z0-9]{1}$/.test(v) || this.$t('The CIF must be valid (Example formats: A12345678, 12345678B, C1234567D)')
                ],
                iban: [
                    v => !!v || this.$t('The account number field is required'),
                    v => !v || /([A-Z]{2})\s*\t*(\d\d)\s*\t*(\d\d\d\d)\s*\t*(\d\d\d\d)\s*\t*(\d\d)\s*\t*(\d\d\d\d\d\d\d\d\d\d)/.test(v) || this.$t('The account number (IBAN) is invalid!(Example format: ES75-1234-1234-1234-1234-1234, without "-")')
                ],
                email: [
                    v => !!v || this.$t('Error.The mail field is required'),
                    v => /.+@.+\..+/.test(v) || this.$t('The mail must be valid.')],
            },
            rules2: {
                cif: [
                    v => this.receiverCif.toUpperCase() !== this.payerCif.toUpperCase() || this.$t('Error.The CIF must be different than yours.'),
                    //v => /^[a-zA-Z0-9]{1}[0-9]{7}[a-zA-Z0-9]{1}$/.test(v) || v === "" || this.$t('The CIF must be valid (Example formats: A12345678, 12345678B, C1234567D)')
                ],
                iban: [
                    v => !v || /([A-Z]{2})\s*\t*(\d\d)\s*\t*(\d\d\d\d)\s*\t*(\d\d\d\d)\s*\t*(\d\d)\s*\t*(\d\d\d\d\d\d\d\d\d\d)/.test(v) || this.$t('The account number (IBAN) is invalid!(Example format: ES75-1234-1234-1234-1234-1234, without "-")')
                ],
                email: [
                    v => /.+@.+\..+/.test(v) || v === "" || this.$t('The mail must be valid.')],
            },
            invoiceTypeClient: false,
            disabledNumber: false,
            disabledPayer: false,
            disabledReceiver: false,
            updatedEmailPayer: true,
            updatedEmailreceiver: true,
            disabledAmount: false,
            disabledType: false,
            userCifText: '',
            userEmailText: ''
        };
    },
    watch: {
        invoiceTypeClient: function isActive (val) {
            if (val) {
                this.imReceiver();
            } else {
                this.imPayer();
            }
        }
    },
    created () {
        // !this.invoice.number ||
        this.isClient = this.invoice.receiverCif === this.$user.cif || this.invoice.payerCif !== this.$user.cif;
        if (!this.invoice.amount || !this.invoice.payerCif || !this.invoice.receiverCif || !this.invoice.number || !this.invoice.payer.email || !this.invoice.receiver.email ) {

            this.payer = typeof this.invoice.payer !== "undefined" && this.invoice.payer._id.toString() === this.invoice.creator.toString();
            this.receiver = !this.payer;
            if (this.payer) {
                this.imPayer();
                this.disabledPayer = true;
                this.disabledReceiver = false;
                this.invoiceTypeClient = false;
            } else if (typeof this.invoice.receiver !== "undefined") {
                this.imReceiver();
                this.disabledPayer = false;
                this.disabledReceiver = true;
                this.invoiceTypeClient = true;
            } else {
                this.disabledPayer = true;
                this.disabledReceiver = true;
            }

            this.number = this.invoice.number;
            this.amount = this.invoice.amount;
            !this.invoice.payerCif ? this.updatedEmailPayer = false : "";
            !this.invoice.receiverCif ? this.updatedEmailreceiver = false : "";
            this.invoice.receiverCif ? this.receiverCif = this.invoice.receiverCif : "";
            this.invoice.payerCif ? this.payerCif = this.invoice.payerCif : "";
            this.receiverCif = this.receiverCif.toUpperCase();
            this.payerCif = this.payerCif.toUpperCase();
            this.invoice.payer && this.invoice.payer.email ? this.payerEmail = this.invoice.payer.email : "";
            this.invoice.receiver && this.invoice.receiver.email ? this.receiverEmail = this.invoice.receiver.email : "";

            this.disabledNumber = !!this.number;
            this.disabledAmount = !!this.amount;
            this.disabledType = typeof this.invoice.payer !== "undefined" || typeof this.invoice.receiver !== "undefined";

            // this.visible = true;

            if (this.invoice.rossumStatus === Constants.ROSSUM.STATUS_SCANNED &&  this.invoice.rossumCollectedInfo) {
                let detectedFields = this.$t('Rossum have detected the next information:');
                let openModal = false;
                if (this.invoice.rossumCollectedInfo.payerCif && !this.disabledPayer) {
                    detectedFields += "<br>";
                    detectedFields += "<b>" + this.$t('Payer cif:') + " </b>" + this.invoice.rossumCollectedInfo.payerCif;
                    openModal = true;
                }
                if (this.invoice.rossumCollectedInfo.receiverCif && !this.disabledReceiver) {
                    detectedFields += "<br>";
                    detectedFields += "<b>" + this.$t('Receiver cif:') + " </b>" + this.invoice.rossumCollectedInfo.receiverCif;
                    openModal = true;
                }
                if (this.invoice.rossumCollectedInfo.amount && !this.disabledAmount) {
                    detectedFields += "<br>";
                    detectedFields += "<b>" + this.$t('Amount:') + " </b>" + this.invoice.rossumCollectedInfo.amount;
                    openModal = true;
                }
                if (this.invoice.rossumCollectedInfo.number && !this.disabledNumber) {
                    detectedFields += "<br>";
                    detectedFields += "<b>" + this.$t('Number:') + " </b>" + this.invoice.rossumCollectedInfo.number;
                    openModal = true;
                }
                if (this.invoice.rossumCollectedInfo.accountNumber && !this.forward) {
                    detectedFields += "<br>";
                    detectedFields += "<b>" + this.$t('InvoiceMissingInformation.Account number:') + " </b>" + this.invoice.rossumCollectedInfo.accountNumber;
                    openModal = true;
                }
                detectedFields += "<br>";
                detectedFields += this.$t('Do you want to import?(in the next screen you can modify the fields)');
                if (openModal) {
                    this.$root.$emit('show-confirmation-modal', {
                        title: this.$t('Import information?'),
                        message: detectedFields,
                        oneButton: false,
                        yes: () => {
                            if (this.invoice.rossumCollectedInfo.payerCif && !this.disabledPayer) {
                                this.payerCif = this.invoice.rossumCollectedInfo.payerCif;
                                this.searchEmail(this.payerCif, 'pay');
                            }
                            if (this.invoice.rossumCollectedInfo.receiverCif && !this.disabledReceiver) {
                                this.receiverCif = this.invoice.rossumCollectedInfo.receiverCif;
                                this.searchEmail(this.receiverCif, 'rec');
                            }
                            if (this.invoice.rossumCollectedInfo.amount && !this.disabledAmount) {
                                this.amount = this.invoice.rossumCollectedInfo.amount;
                            }
                            if (this.invoice.rossumCollectedInfo.number && !this.disabledNumber) {
                                this.number = this.invoice.rossumCollectedInfo.number;
                            }
                            if (this.invoice.rossumCollectedInfo.accountNumber && !this.forward) {
                                this.account = this.invoice.rossumCollectedInfo.accountNumber;
                            }
                            this.visible = true;
                        },
                        no: () => {
                            this.visible = true;
                        }
                    });
                } else {
                    this.visible = true;
                }
            } else {
                this.visible = true;
            }
        } else {
            this.$emit('InvoiceMissingInformation.update');
        }
        this.getUsers();
    },
    methods: {
        imReceiver () {
            if (!this.disabledType) {
                this.receiver = !this.receiver;
                this.payer = false;
                if (this.receiver) {
                    this.colorC = "accepted";
                    this.colorP = "primary";
                } else {
                    this.colorC = this.colorP = "primary";
                }
                this.payerCif = '';
                this.receiverCif = this.$user.cif;
                this.disabledReceiver = true;
                this.disabledPayer = false;
            }
        },
        searchEmail (cif, who) {
            ApiRepository.getUserByCif(cif)
                .then((res) => {
                    if (res.data.email !== "") {
                        if (who === "pay" ) {
                            this.payerEmail = res.data.email;
                            this.updatedEmailPayer = true;
                        } else {
                            this.receiverEmail = res.data.email;
                            this.updatedEmailreceiver = true;
                        }
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        imPayer () {
            if (!this.disabledType) {
                this.payer = !this.payer;
                this.receiver = false;
                if (this.payer) {
                    this.colorP = "payer";
                    this.colorC = "primary";
                } else {
                    this.colorC = this.colorP = "primary";
                }

                this.receiverCif = '';
                this.payerCif = this.$user.cif;
                this.disabledPayer = true;
                this.disabledReceiver = false;
            }
        },
        calculateComissions () {
            ApiRepository.getFactorComission()
                .then((res) => {
                    this.factorComission = this.value * res.data.factorComission;
                    this.factorComission = this.factorComission.toFixed(2);
                })
                .catch((err) => {
                    let missatge = "";
                    if (err.response.data.errorCode === Constants.ERRORS.ERROR_EXISTING_INVOICE) {
                        missatge = this.$t('ERROR: Something went wrong');
                    } else if (err.response.data.errorCode === Constants.ERRORS.ERROR_SAVING_INVOICE) {
                        missatge = this.$t('ERROR: The invoice couldn\'t be saved, try again');
                    }
                    this.$root.$emit('show-snackbar', {message: missatge, color: 'error'});
                    this.$emit('error');
                    //this.onClose();
                    console.error(err);
                });
            ApiRepository.getPayerComission()
                .then((response) => {
                    this.payerComission = this.value * response.data.payerComission;
                    this.payerComission = this.payerComission.toFixed(2);
                })
                .catch((err) => {
                    let missatge = "";
                    if (err.response.data.errorCode === Constants.ERRORS.ERROR_EXISTING_INVOICE) {
                        missatge = this.$t('ERROR: Something went wrong');
                    } else if (err.response.data.errorCode === Constants.ERRORS.ERROR_SAVING_INVOICE) {
                        missatge = this.$t('ERROR: The invoice couldn\'t be saved, try again');
                    }
                    this.$root.$emit('show-snackbar', {message: missatge, color: 'error'});
                    this.$emit('error');
                    //this.onClose();
                    console.error(err);
                });
        },
        saveInvoice () {
            ApiRepository.updateInvoiceList(this.invoice._id, this.number, this.amount, this.receiverCif,  this.payerCif, this.account, this.payerEmail, this.receiverEmail)
                .then((response) => {
                    this.$emit('InvoiceMissingInformation.update');
                    this.visible = false;
                })
                .catch((err) => {
                    this.visibleInoMiss = false;
                    this.$root.$emit('show-snackbar', {message: this.$t('The invoice number you have entered already exists'), color: 'error'});
                    this.$emit('error');
                    console.error(err);
                });
        },
        noInfo () {
            this.$emit('back');
            //this.$router.go(-1);
        },
        async addContact () {
            let contactNameExists = false;
            let contactNIFExists = false;
            let contactEmailExists = false;

            for (const user of this.usersList) {
                if (user.name === this.contactName) contactNameExists = true;
                if (user.cif === this.contactNIF) contactNIFExists = true;
                if (user.email === this.contactEmail) contactEmailExists = true;
            }

            if (contactNameExists) {
                this.$root.$emit('show-snackbar', {message: this.$t('Name duplicated'), color: "error"});
            } else if (contactNIFExists) {
                this.$root.$emit('show-snackbar', {message: this.$t('NIF duplicated'), color: "error"});
            } else if (contactEmailExists) {
                this.$root.$emit('show-snackbar', {message: this.$t('Email duplicated'), color: "error"});
            } else {
                const contact = {
                    cif: this.contactNIF,
                    name: this.contactName,
                    email: this.contactEmail
                };
                await ApiRepository.addContact(this.$user.cif, contact).then(() => {
                    if (this.disabledReceiver) {
                        //payer
                        this.payerCif = this.contactNIF;
                    } else {
                        //receiver
                        this.receiverCif = this.contactNIF;
                    }
                    this.modalContact = false;
                    this.contactName = null;
                    this.contactNIF = null;
                    this.contactEmail = null;
                    this.$root.$emit('show-snackbar', {message: this.$t('Contact added successfully!'), color: "success"});
                    this.getUsers();
                });
            }
        },
        getUserByCif (cif) {
            for (const user of this.usersList) {
                if (user.cif.toLowerCase() === cif.toLowerCase()) {
                    this.contactUser = user;
                    this.otherSelectedUser = user.name + ", " + user.cif + ", " + user.email;
                }
            }
        },
        async getUsers () {
            await ApiRepository.getContacts(this.$user.cif).then((res) => {
                //Check reciever or payer  
                if (this.disabledReceiver) {
                    //payer
                    this.contactNIF = this.payerCif;
                    this.contactEmail = this.payerEmail;
                    this.receiverEmail = this.$user.email;
                } else {
                    //reciever
                    this.contactNIF = this.receiverCif;
                    this.contactEmail = this.receiverEmail;
                    this.payerEmail = this.$user.email;
                }
                this.usersList = res.data.contacts;
                this.usersName = [];
                for (const user of this.usersList) {
                    this.usersName.push(user.name + ", " + user.cif + ", " + user.email);
                }
                this.getUserByCif(this.contactNIF);
                if (this.disabledReceiver) {
                    //payer
                    this.payerCif = this.contactUser.cif;
                    this.payerEmail = this.contactUser.email;
                } else {
                    //reciever
                    this.receiverCif = this.contactUser.cif;
                    this.receiverEmail = this.contactUser.email;
                }
            })
                .catch((err) => {
                    console.log("ERROR: " + err);
                });
        },
        onChange (value) {
            const cif_other = value.split(', ');
            this.contactEmail = cif_other[2];
            this.contactNIF = cif_other[1];
            this.contactName = cif_other[0];
            if (this.disabledReceiver) {
                //payer
                this.payerCif = this.contactNIF;
                this.payerEmail = this.contactEmail;
            } else {
                //reciever
                this.receiverCif = this.contactNIF;
                this.receiverEmail = this.contactEmail;
            }
        },
    }
};
</script>

<style scoped>

</style>
